<template>
  <v-dialog :value="isActive" @click:outside="$emit('update:isActive', false)" width="400px">
    <v-card>
      <v-card-title class="primary white--text d-flex justify-space-between">
        <span>Process invoices</span>
        <v-btn text icon dark @click="$emit('update:isActive', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-container>
        <custom-form
          :fields="invoices"
          method="get"
          :action="url"
          @submitted="$emit('downloaded', $event)"
        >
          <v-container>
            <v-row no-gutters>
              <v-col cols="12">
                <custom-input name="email" label="Email to Receive Invoices" />
              </v-col>
            </v-row>
          </v-container>
          <custom-button block color="primary">
            <v-icon>mdi-folder-sync-outline</v-icon>
            Process Invoices
          </custom-button>
        </custom-form>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    isActive: { required: true, type: Boolean },
  },
  data() {
    return {
      invoices: { email: "admin@danapay.io" },
      url: `/api/v1/processCompletePaymentsInvoices`,
    };
  },
};
</script>
